import { useNavigate } from "react-router-dom";
import { AccessDeniedState, EntitlementDeniedState, ErrorState } from "@odingard/design-system";
import { ApiError } from "@odingard/sdk-client";

export function CaiError({ error, onRetry }: { error: Error; onRetry?: () => void }) {
  const navigate = useNavigate();
  if (error instanceof ApiError) {
    if (error.code === "entitlement_denied") {
      return <EntitlementDeniedState product="Contract AI" onUpgrade={() => navigate("/pricing")} />;
    }
    if (error.status === 403) {
      return <AccessDeniedState reason={error.message} />;
    }
  }
  return <ErrorState description={error.message} {...(onRetry ? { onRetry } : {})} />;
}
